// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// svg
import { GeneralChat, GeneralStar } from '/react4xp/components/Svg/Icons/General'

// prop types
interface ProductCardProps {
    href?: string
    external?: boolean
    src?: string
    srcMedium?: string
    alt?: string
    width?: number
    sizes?: string
    title?: string
    comments?: string
    rating?: string
    noCommentsRating?: boolean
    className?: string
    tag?: string
}

export default function ProductCard({
    href,
    external,
    src,
    srcMedium,
    alt,
    width,
    sizes,
    title,
    comments,
    rating,
    className,
    noCommentsRating,
    tag,
    ...rest
}: ProductCardProps) {
    return (
        <a
            href={href}
            target={external ? '_blank' : undefined}
            className={clsx(
                'product-card',
                className
            )}
            {...rest}
        >
            <div className='product-card__mask'>

                {src && (
                    <div className='product-card__image'>
                        <Image
                            src={src}
                            srcMedium={srcMedium}
                            alt={alt}
                            width={width}
                            sizes={sizes}
                        />
                    </div>
                )}

                <div className={clsx(
                    'product-card__wrapper',
                    noCommentsRating && 'product-card__wrapper--no-comments-rating'
                )}>

                    {isNonWhitespaceString(tag) && (
                        <div className='product-card__wrapper__tag text-smaller semi-bold'>
                            {tag}
                        </div>
                    )}

                    {isNonWhitespaceString(title) && (
                        <h3 className='product-card__wrapper__title h5'>
                            {title}
                        </h3>  
                    )}

                    {/*
                    {noCommentsRating ?? (
                        <div className='product-card__wrapper__icons text-smaller'>

                            <span className='product-card__wrapper__icons__item'>
                                <GeneralChat variant='outline' />
                                <span>
                                    {comments ? comments : '0'}
                                </span>
                            </span>
                            
                            <span className='product-card__wrapper__icons__item'>
                                <GeneralStar variant='outline' />
                                <span>
                                    {rating ? rating : '--'}
                                </span>
                            </span>

                        </div>
                    )}
                    */}
                    
                </div>

            </div>

        </a>
    )
}